// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"957c653f","247":"a050a4d1","284":"a304c347","453":"c220346b","627":"a97dff5b","867":"08adea31","923":"c4b5ed36","938":"e373bcf9"}[chunkId] + ".chunk.js";
};